import randomId from 'random-id';
import { createFormForCollection, getFormComponents } from '../../collectionForm/formComponent';

export default function (editor, opts = {}) {
  const option = opts;
  const { projectId, collections, version } = option;
  const domc = editor.DomComponents;
  const formCheckboxId = 'dc-login-rememberme-' + randomId(8, '');

  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  domc.addType('login-form', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: 'Login Form',
          droppable: ':not(form)',
          draggable: ':not(form)',
          projectId: projectId,
          isDrop: false,
          traits: [
            {
              type: 'webconnect-event',
              label: false,
              name: 'onsubmit',
            },
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
        },
        async init() {
          if (!this.get('isDrop')) {
            await this.createComponentItems(projectId);
            this.set('isDrop', true);
          }
        },
        async createComponentItems(projectId) {
          const collection = await getFormComponents('user', collections);
          if (collection) {
            collection.fields = collection.fields.filter((field) => {
              return (
                field.fieldName !== 'userRoles' &&
                field.fieldName !== 'is_enabled' &&
                field.fieldName !== 'is_email_verified'
              );
            });
            const formElements = await createFormForCollection(
              collection,
              projectId,
              version,
              collections,
            );
            if (formElements) {
              let form = `
                <div class="col-12 col-md-12">
                  <h4 class="title">Login Form</h4>
                </div>
                <div class="form-container row mx-auto" draggable="false" data-gjs-copyable="false" data-gjs-selectable="true" data-gjs-custom-name="Form Container">
                  <div class="alert alert-danger alert-message" style="display: none"></div>
                  <div class="alert alert-success success-message" style="display: none"></div>
                  ${formElements}
                  <div class="form-group col-12 col-md-12">
                    <input class="form-check-input dc-checkbox" id="${formCheckboxId}" type="checkbox">
                    <label class="form-check-label" for="${formCheckboxId}">Remember me</label>
                  </div>
                  <div class="form-group p-t-10 no-border-bottom col-12 col-md-12">
                    <button type="submit" class="btn btn-primary">Login</button>
                    <a href="/signup" class="btn btn-primary ms-2 ml-2 text-bg-primary">Signup/Register</a>
                    <a href="/forgot-password" class="btn btn-primary ms-2 ml-2 text-bg-primary">Forgot password?</a>
                    <a id="facebookLogin" class="btn btn-primary ms-2 ml-2 text-bg-primary" onclick="loginUsingFacebook(); return false;" href="#" role="button">Facebook</a>
                  </div>
                </div>`;
              this ? this.components(form) : '';
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'login-form') {
            return {
              type: 'login-form',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {},
    }),
  });
}
